import React, { useRef } from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomImage from "../CustomImage"; 
import Card from "react-bootstrap/Card";
import { sliderSpeed } from "../../utils/constants";
import LazyReveal from "../LazyReveal";

interface Props {
  eventData: any;
}

const WhoWillMeetSection: React.FC<Props> = ({ eventData }) => {
  const sliderRef = useRef<Slider>(null);
  const settings = {
    infinite: true,
    arrows: false,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: sliderSpeed.desktopAutoplaySpeed,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: sliderSpeed.mobileAutoplaySpeed,
        }
      }
    ]
  };

  return (
    <LazyReveal className={styles.whoWillYouMeet} style={{ background: eventData?.whoYouMeetSection?.sectionBgColor || '#F7F8F7' }}>
      <div>
        <Container>
          <Row>
            <div className={styles.heading}>
              <h2>{eventData?.whoYouMeetSection?.sectionTitle}</h2>
            </div>
          </Row>
        </Container>
        <Container>
          <Row>
            <div className={styles.whoyoumeetslider}>
              <Slider {...settings} className={styles.slider} ref={sliderRef}>
                {
                  eventData?.whoYouMeetSection?.whoYouMeet?.length > 0 &&
                  eventData?.whoYouMeetSection?.whoYouMeet.map((section: any) => {
                    return (
                      <Col xl={3} lg={3} md={3} xs={12}>
                        <Card className={styles.card}>
                          <div className={styles.cardImgDiv}>
                            <CustomImage src={section?.imagePath} width={313} height={207} className={styles.cardImg} layout="responsive" alt="University-Representative.png" />
                          </div>
                          <Card.Body className={styles.cardBody}>
                            <h4>{section?.title}</h4>
                            <p>{section?.description}</p>
                          </Card.Body>
                        </Card>
                      </Col>
                    )
                  })
                }
              </Slider>
            </div>
          </Row>
        </Container>
      </div>
    </LazyReveal>
  )
}

export default WhoWillMeetSection;
